export const clearSelection = "YNb";
export default {clearSelection};